// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/bg-login.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  background-image: url("https://landing.5cnetwork.com/icons/remote-radiology-interpretation.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  /* Set the styling for the login box */
  background-color: #fff; /* Set the background color for the login box */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}


  .login-form {
    padding: 24px;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.8); /* Use rgba to add opacity */
    max-width: 400px; /* Adjust the width of the form as needed */
    width: 80%; /* Set a fixed width for the form */
  }
  
  .login-heading {
    text-align: center;
    font-size: 24px;
    margin-bottom: 24px;
    color: #333;
  }
  
  .form-group {
    margin-bottom: 16px;
  }
  
  .form-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .login-btn {
    width: 100%;
    padding: 12px;
    background-color: #1F2B8F;
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .login-btn:hover {
    background-color: #12358F;
  }
  
  .background-image {
    position: relative;
    width: 100%;
    height: 500px; /* Set the desired height for the background image */
    background-image: url("https://landing.5cnetwork.com/icons/remote-radiology-interpretation.svg");
    background-size: cover;
    background-position: center;
  }
  
  .background-image::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Adjust the alpha value (0.5) to control the darkness */
    pointer-events: none; /* Make the overlay transparent to mouse events */
  }
  
  .overlay {
    /* Add an overlay on top of the background image */
    background-color: rgba(0, 0, 0, 0.6); /* Use RGBA to specify opacity */
    /* You can adjust the opacity value (0.6) to make it lighter or darker */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  


  .login{
    /* background-image: url('./Images/login.png'); */
    /* background-image: url('https://images.unsplash.com/photo-1544377193-33dcf4d68fb5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1032&q=80'); */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 100vh;
    background-repeat: no-repeat;
    opacity: 0.7 ;
    position: relative;
    background-size: cover;
  
  }
  .img{
    position: absolute;
    margin-left: auto;
    align-self: flex-start;
    left:3%;
    width: 150px;
    /* height: 100px; */
    margin-top: 40px;
    margin-left: 0px;
  }
  /* .login-top{
      align-self: flex-start;
  } */
  .login-main{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  .login-div{
    padding-bottom: 20px;
    width: 350px;
    height: -moz-fit-content;
    height: fit-content;
    background-color: white;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 0 10px #b1bacc;
  }
  
  .login-div:hover{
    
    transform: scale(1.05); 
    box-shadow: 0 0 8px #b1bacc;
    
  }

  .log {
    cursor: pointer;
    border: 0;
    border-radius: 4px;
    font-weight: 600;
    margin: 0 10px;
    width: 200px;
    padding: 10px 0;
    box-shadow: 0 0 20px rgba(104, 85, 224, 0.2);
    transition: 0.4s;
  }
  
  .reg {
    color: white;
    background-color: #7ea5ff;
  }
  
  .log {
    color: #7ea5ff;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid #7ea5ff;
    margin-bottom: 30px;
  }
  
  .log:hover {
    color: white;
    /* width:; */
    box-shadow: 0 0 20px #7ea5ff;
    background-color: #7ea5ff;
  }
  
  /* .login-top{
    display: flex;
    justify-content: space-between;
  } */
  
  
  
  
  
  
  .title{
    text-align: center;
    margin-top: 30px;
    font-weight: bolder;
    font-size: 30px;
    color: red;
    /* opacity: 0.7; */
  }
  
  
  .inputs{
    margin-top: -10px;
  }
  
  .inputs>input{
    border: 1px solid grey;
    padding: 12px 20px;
    margin: 20px 10px;
    width: 60%;
    border-radius: 50px;
    font-size: small;
  }
  .btn{
   margin-top: 5px;
    background-color: #0010D9;
    color:#fff;
    font-size: 17px !important;
    border: none;
    cursor: pointer;
    padding: 5px 20px;
    border-radius: 3px;
    opacity: 0.8;
  }
  
  .btn:hover{
    background-color: lightgray;
    color: #000;
  }
  
  .items{
    position: absolute;
    background-color: white;
    margin-left: 82%;
    margin-top: 20px;
    width: 200px;
    text-align: center;
    display: none;
  }
  
  .items>div{
    padding: 5px;
  }
  
  .error{
    padding-top: 20px;
    text-align: left;
    /* margin-top: 30px; */
    margin-left: 55px;
    font-size: 15px;
  }
  
  .menu_icon{
    width: 25px;
    cursor: pointer;
    /* margin-left: 92px; */
    /* padding-left: 11px; */
    position: fixed;
    margin-left: 80px;
    padding-left: 15px;
  
  }
  
  .img2{
    position: absolute;
    display: flex;
    /* justify-content:  end; */
    justify-content: end;
    width: 100%;
    align-self: flex-start; 
   padding-right: 150px;
   margin-top: 30px;
   margin-right: 180px;
  }
  
  
  /* .menu-container{ */
    /* height:fit-content; */
    /* display: inline-block; */
    /* width: fit-content;
    padding-bottom: 10px;;
  } */
  .dropdown-content{
    border-radius: 5px;
    padding: 5px;
      display: none;
      height: -moz-fit-content;
      height: fit-content; 
      position: absolute; 
      /* top: 28px;  */
        /*Adjust the distance from the menu button */
      background-color: #0010D9;
      opacity: 0.7;
      /* box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.2); */   
  }
  
  
  .dropdown-content > a {
    display: block;
    color: white;
    align-items: center; 
    padding: 5px 10px;
    text-decoration: none;
    border-radius: 3px;
  }
  
  .dropdown-content > a:hover{
    background-color: gray;
    cursor: pointer;  
  } 
  
  
  .menu-container:hover .dropdown-content{
    display: block;
  }
  
  .dropdown-content>a:hover{
      transform: scale(1.05);
  }
  
  /* .dropdown-content:hover .img2{
    display: none;
  } */
  
  
  .dropdown-content:hover{
    display: block;
  }
  
  .login-div p{
    margin-top: 0px;
  }
  .login-div p a{
    text-decoration: none;
  }`, "",{"version":3,"sources":["webpack://./src/Login/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,gGAAgG;EAChG,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;;EAE5B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB,EAAE,+CAA+C;EACvE,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;;EAGE;IACE,aAAa;IACb,kBAAkB;IAClB,0CAA0C,EAAE,4BAA4B;IACxE,gBAAgB,EAAE,2CAA2C;IAC7D,UAAU,EAAE,mCAAmC;EACjD;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa,EAAE,oDAAoD;IACnE,gGAAgG;IAChG,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,yDAAyD;IAC/F,oBAAoB,EAAE,iDAAiD;EACzE;;EAEA;IACE,kDAAkD;IAClD,oCAAoC,EAAE,gCAAgC;IACtE,wEAAwE;IACxE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;EACd;;;;EAIA;IACE,iDAAiD;IACjD,kMAAkM;IAClM,yDAAgD;IAChD,aAAa;IAEb,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,sBAAsB;;EAExB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;;KAEG;EACH;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,YAAY;IACZ,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;;IAEE,sBAAsB;IACtB,2BAA2B;;EAE7B;;EAEA;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,4CAA4C;IAC5C,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA;;;KAGG;;;;;;;EAOH;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,kBAAkB;EACpB;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;EAClB;EACA;GACC,eAAe;IACd,yBAAyB;IACzB,UAAU;IACV,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;EAEpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,oBAAoB;IACpB,WAAW;IACX,sBAAsB;GACvB,oBAAoB;GACpB,gBAAgB;GAChB,mBAAmB;EACpB;;;EAGA,qBAAqB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B;;KAEC;EACH;IACE,kBAAkB;IAClB,YAAY;MACV,aAAa;MACb,wBAAmB;MAAnB,mBAAmB;MACnB,kBAAkB;MAClB,gBAAgB;QACd,4CAA4C;MAC9C,yBAAyB;MACzB,YAAY;MACZ,iDAAiD;EACrD;;;EAGA;IACE,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;;EAGA;IACE,cAAc;EAChB;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;;KAEG;;;EAGH;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB","sourcesContent":[".login-container {\n  background-image: url(\"https://landing.5cnetwork.com/icons/remote-radiology-interpretation.svg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-box {\n  /* Set the styling for the login box */\n  background-color: #fff; /* Set the background color for the login box */\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n\n  .login-form {\n    padding: 24px;\n    border-radius: 8px;\n    background-color: rgba(255, 255, 255, 0.8); /* Use rgba to add opacity */\n    max-width: 400px; /* Adjust the width of the form as needed */\n    width: 80%; /* Set a fixed width for the form */\n  }\n  \n  .login-heading {\n    text-align: center;\n    font-size: 24px;\n    margin-bottom: 24px;\n    color: #333;\n  }\n  \n  .form-group {\n    margin-bottom: 16px;\n  }\n  \n  .form-input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n  }\n  \n  .login-btn {\n    width: 100%;\n    padding: 12px;\n    background-color: #1F2B8F;\n    color: #fff;\n    font-weight: bold;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .login-btn:hover {\n    background-color: #12358F;\n  }\n  \n  .background-image {\n    position: relative;\n    width: 100%;\n    height: 500px; /* Set the desired height for the background image */\n    background-image: url(\"https://landing.5cnetwork.com/icons/remote-radiology-interpretation.svg\");\n    background-size: cover;\n    background-position: center;\n  }\n  \n  .background-image::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* Adjust the alpha value (0.5) to control the darkness */\n    pointer-events: none; /* Make the overlay transparent to mouse events */\n  }\n  \n  .overlay {\n    /* Add an overlay on top of the background image */\n    background-color: rgba(0, 0, 0, 0.6); /* Use RGBA to specify opacity */\n    /* You can adjust the opacity value (0.6) to make it lighter or darker */\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n  \n\n\n  .login{\n    /* background-image: url('./Images/login.png'); */\n    /* background-image: url('https://images.unsplash.com/photo-1544377193-33dcf4d68fb5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1032&q=80'); */\n    background-image: url('../Images/bg-login.webp');\n    height: 100vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n    opacity: 0.7 ;\n    position: relative;\n    background-size: cover;\n  \n  }\n  .img{\n    position: absolute;\n    margin-left: auto;\n    align-self: flex-start;\n    left:3%;\n    width: 150px;\n    /* height: 100px; */\n    margin-top: 40px;\n    margin-left: 0px;\n  }\n  /* .login-top{\n      align-self: flex-start;\n  } */\n  .login-main{\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n  }\n  .login-div{\n    padding-bottom: 20px;\n    width: 350px;\n    height: fit-content;\n    background-color: white;\n    border-radius: 10px;\n    text-align: center;\n    box-shadow: 0 0 10px #b1bacc;\n  }\n  \n  .login-div:hover{\n    \n    transform: scale(1.05); \n    box-shadow: 0 0 8px #b1bacc;\n    \n  }\n\n  .log {\n    cursor: pointer;\n    border: 0;\n    border-radius: 4px;\n    font-weight: 600;\n    margin: 0 10px;\n    width: 200px;\n    padding: 10px 0;\n    box-shadow: 0 0 20px rgba(104, 85, 224, 0.2);\n    transition: 0.4s;\n  }\n  \n  .reg {\n    color: white;\n    background-color: #7ea5ff;\n  }\n  \n  .log {\n    color: #7ea5ff;\n    background-color: rgba(255, 255, 255, 1);\n    border: 1px solid #7ea5ff;\n    margin-bottom: 30px;\n  }\n  \n  .log:hover {\n    color: white;\n    /* width:; */\n    box-shadow: 0 0 20px #7ea5ff;\n    background-color: #7ea5ff;\n  }\n  \n  /* .login-top{\n    display: flex;\n    justify-content: space-between;\n  } */\n  \n  \n  \n  \n  \n  \n  .title{\n    text-align: center;\n    margin-top: 30px;\n    font-weight: bolder;\n    font-size: 30px;\n    color: red;\n    /* opacity: 0.7; */\n  }\n  \n  \n  .inputs{\n    margin-top: -10px;\n  }\n  \n  .inputs>input{\n    border: 1px solid grey;\n    padding: 12px 20px;\n    margin: 20px 10px;\n    width: 60%;\n    border-radius: 50px;\n    font-size: small;\n  }\n  .btn{\n   margin-top: 5px;\n    background-color: #0010D9;\n    color:#fff;\n    font-size: 17px !important;\n    border: none;\n    cursor: pointer;\n    padding: 5px 20px;\n    border-radius: 3px;\n    opacity: 0.8;\n  }\n  \n  .btn:hover{\n    background-color: lightgray;\n    color: #000;\n  }\n  \n  .items{\n    position: absolute;\n    background-color: white;\n    margin-left: 82%;\n    margin-top: 20px;\n    width: 200px;\n    text-align: center;\n    display: none;\n  }\n  \n  .items>div{\n    padding: 5px;\n  }\n  \n  .error{\n    padding-top: 20px;\n    text-align: left;\n    /* margin-top: 30px; */\n    margin-left: 55px;\n    font-size: 15px;\n  }\n  \n  .menu_icon{\n    width: 25px;\n    cursor: pointer;\n    /* margin-left: 92px; */\n    /* padding-left: 11px; */\n    position: fixed;\n    margin-left: 80px;\n    padding-left: 15px;\n  \n  }\n  \n  .img2{\n    position: absolute;\n    display: flex;\n    /* justify-content:  end; */\n    justify-content: end;\n    width: 100%;\n    align-self: flex-start; \n   padding-right: 150px;\n   margin-top: 30px;\n   margin-right: 180px;\n  }\n  \n  \n  /* .menu-container{ */\n    /* height:fit-content; */\n    /* display: inline-block; */\n    /* width: fit-content;\n    padding-bottom: 10px;;\n  } */\n  .dropdown-content{\n    border-radius: 5px;\n    padding: 5px;\n      display: none;\n      height: fit-content; \n      position: absolute; \n      /* top: 28px;  */\n        /*Adjust the distance from the menu button */\n      background-color: #0010D9;\n      opacity: 0.7;\n      /* box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.2); */   \n  }\n  \n  \n  .dropdown-content > a {\n    display: block;\n    color: white;\n    align-items: center; \n    padding: 5px 10px;\n    text-decoration: none;\n    border-radius: 3px;\n  }\n  \n  .dropdown-content > a:hover{\n    background-color: gray;\n    cursor: pointer;  \n  } \n  \n  \n  .menu-container:hover .dropdown-content{\n    display: block;\n  }\n  \n  .dropdown-content>a:hover{\n      transform: scale(1.05);\n  }\n  \n  /* .dropdown-content:hover .img2{\n    display: none;\n  } */\n  \n  \n  .dropdown-content:hover{\n    display: block;\n  }\n  \n  .login-div p{\n    margin-top: 0px;\n  }\n  .login-div p a{\n    text-decoration: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
